import { render, staticRenderFns } from "./viewList.vue?vue&type=template&id=46d86058&scoped=true&"
import script from "./viewList.vue?vue&type=script&lang=ts&"
export * from "./viewList.vue?vue&type=script&lang=ts&"
import style0 from "./viewList.vue?vue&type=style&index=0&id=46d86058&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d86058",
  null
  
)

export default component.exports